import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { useEnemiesOfStress } from "stores";
import { FormSelectInput } from "form";
import checkIfEnemyInFilteredEnemies from "./checkIfEnemyInFilteredEnemies";
import { sortObjectsByProperty } from "utils/sortUtils";

const stressTypeIsAbiotic = (isEn, stressType) =>
  stressType === (isEn ? "Abiotic stress" : "Αβιοτική καταπόνηση");

const EnemySelectInput = ({ isViewMode, isNewVersion }) => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language.startsWith("en");

  const { values, handleChange, setFieldValue, setValues, validateForm } =
    useFormikContext();

  const { enemies, fetchState } = useEnemiesOfStress(values?.caused?.stressId);
  const enemiesOptions = useMemo(
    () =>
      enemies
        ?.map(({ uuid, name }) => ({
          value: uuid,
          label: isEn ? name?.nameEn : name?.nameGr,
        }))
        .sort((a, b) => sortObjectsByProperty(a, b, "label")) ?? [],
    [enemies, isEn],
  );

  useEffect(() => {
    checkIfEnemyInFilteredEnemies(
      isViewMode,
      values,
      setValues,
      enemiesOptions,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enemiesOptions]);

  if (!isNewVersion && enemiesOptions.length === 0) {
    return null;
  }

  const enemyTitle = stressTypeIsAbiotic(isEn, values?.stressType)
    ? "ActionModal.Defficiency"
    : "ActionModal.Enemy";

  const handleEnemyChange = (e) => {
    handleChange(e);
    const enemyId = e.target.value;
    setFieldValue(
      "caused.enemyName",
      enemiesOptions.filter((enemy) => enemy.value === enemyId)[0]?.name
        ?.nameGr || "Missing info",
    ).then(() => validateForm());
  };

  return (
    <FormSelectInput
      name="caused.enemyId"
      isViewMode={isViewMode}
      placeholder={t(enemyTitle)}
      onChange={handleEnemyChange}
      isDisabled={!values?.caused?.stressId || fetchState.isLoading}
      isLoading={!!values?.caused?.stressId && fetchState.isLoading}
      shouldHaveErrorBehaviorAfterSubmit
      options={enemiesOptions}
    />
  );
};

export default EnemySelectInput;
